<template>
  <header class="head">
    <div class="head__container">
      <router-link to="/">
        <img
            class="head__image"
            :src="require('../../assets/images/logo_coq.png')"
        />
      </router-link>
      <div class="head__title">Club des ornithologues <br/>de Québec</div>
      <img
          class="head__bird"
          :src="require('../../assets/images/bird_header.png')"
      />
    </div>
    <!-- TODO -->
    <div class="head__menu">
      <div class="head__menu__container">
        <ul>
          <li>
            <router-link :to="{ name: 'FaireDonPage' }">
              Faire un don
            </router-link>
          </li>
          <template v-if="connected">
            <li>
              <router-link :to="{ name: 'BoutiquePage' }">
                Boutique
              </router-link>
            </li>
          </template>
          <li>
            <router-link :to="{ name: 'ContactPage' }">
              Nous contacter
            </router-link>
          </li>

          <div>
            <template v-if="connected">
              <li>
                <router-link :to="{ name: 'MembersPage' }">
                  Section membre
                </router-link>
              </li>
              <li @click="disconnect(true)"><a href="#">Déconnexion</a></li>
            </template>
            <template v-else>
              <li>
                <router-link :to="{ name: 'DevenirMembrePage' }">
                  Devenir membre
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'LoginPage' }">
                  Connexion membre
                </router-link>
              </li>
            </template>
          </div>
        </ul>

        <div style="position: absolute; top: 10px; right: 10px">
          <router-link :to="{ name: 'CartPage' }" class="head__menu__cart">
            <font-awesome-icon :icon="'shopping-cart'" size="lg"/>
            ({{ getNumberOfItemsInCart }})
          </router-link>
          <!-- Icone Facebook -->
          <a
              href="https://www.facebook.com/groups/565783517668485/?ref=pages_profile_groups_tab&source_id=194006763977977"
              target="_blank"
              class="head__menu__facebook"
          >
            <font-awesome-icon :icon="['fab', 'facebook']" size="2x"/>
          </a>

        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import Eventbus from '../../eventbus';
  import _ from 'lodash';

  export default {
    name: 'topBar',
    mounted() {
      Eventbus.$on('logout', () => {
        this.disconnect(false);
      });
    },
    computed: {
      ...mapState({
        cartNumber: state => state.cart.all.items.length,
        connected: state => state.account.status.loggedIn
      }),
      ...mapGetters('orders', {
        cart: 'cart'
      }),
      getNumberOfItemsInCart() {
        if (this.cart && this.cart.paid === true) {
          return 0;
        }
        let n = 0;
        if (this.cart) {
          for (const p of this.cart.products) {
            n += p.quantity;
          }
          n += _.size(this.cart.registrations);
          if (this.cart.donation && this.cart.donation.amount && this.cart.donation.amount > 0) {
            n += 1;
          }
        }
        return n;
      }
    },
    methods: {
      ...mapActions('account', {
        logout: 'logout'
      }),
      disconnect(redirect = true) {
        this.logout();
        this.$store.commit('orders/setCart', null);
        if (redirect) {
          this.$router.push({ name: 'HomePage' });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  header {
    padding: 0;
  }

  header ul {
    display: block;
    line-height: normal;
  }

  header ul li {
    font-size: 14px;
  }

  $height: 210px;

  .head {
    height: $height;
    //width: 930px;
    margin: auto;
    position: relative;
    background: rgb(212, 235, 250);
    background: linear-gradient(
            90deg,
            rgb(231, 243, 250) 0%,
            rgba(26, 119, 185, 1) 100%
    );

    &__container {
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
      height: $height;
      position: relative;
    }

    &__image {
      position: absolute;
      left: 15px;
      user-select: none;
      height: 162px;
      top: 5px;
    }

    &__title {
      position: absolute;
      right: 150px;
      color: black;
      text-align: left;
      user-select: none;
      top: 44px;
      font-size: 1.8rem;
      left: 193px;
    }

    &__bird {
      position: absolute;
      right: 16px;
      bottom: 30px;
      user-select: none;
    }

    &__menu {
      position: relative;
      top: -46px;
      left: 0;
      right: 0;
      box-shadow: 5px 5px 10px rgba(149, 149, 149, 0.19);
      user-select: all;
      background-color: #ebeef3;
      border: 1px solid rgba(194, 196, 200, 0.56);

      &__cart {
        margin-right: 10px;
        position: absolute;
        top: 5px;
        right: 69px;
        width: 37px;
        color: black;
      }

      &__twitter {
        position: absolute;
        right: 0px;
        color: #1DA1F2;

        :hover {
          color: lighten(#1DA1F2, 10);
        }
      }

      &__facebook {
        position: absolute;
        right: 40px;
        color: #4267B2;

        :hover {
          color: lighten(#4267B2, 10);
        }
      }

      &__container {
        width: 1000px;
        margin-left: auto;
        margin-right: auto;
        position: relative;
      }

      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
      }

      li {
        float: left;
        user-select: none;
      }

      li a {
        display: block;
        color: #b1661b;
        text-align: center;
        padding: 16px;
        text-decoration: none;
        font-weight: 600;
        user-select: none;
      }

      li a:hover {
        background-color: #ebeef3;
      }
    }
  }
</style>
